export default "__VITE_ASSET__IYEiJMbJ__"